// frontend/src/routes/AppRoutes.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Public Pages
import Home from "../pages/Home";
import News from "../pages/News";
import NewsDetail from "../pages/NewsDetail";
import Competitions from "../pages/Competitions";
import Clubs from "../pages/Clubs";
import ClubDetails from "../pages/ClubDetails";
import Players from "../pages/Players";
import PlayerDetails from "../pages/PlayerDetails";
import Tournaments from "../pages/Tournaments";
import TournamentDetails from "../pages/TournamentDetails";
import About from "../pages/About";
import Contact from "../pages/Contact";
import Login from "../pages/Login";

// Layouts
import PublicLayout from "../components/layouts/PublicLayout";
import DashboardLayout from "../components/layouts/DashboardLayout";

// Auth
import ProtectedRoute from "../components/common/ProtectedRoute";

// Sidebars
import Sidebar from "../components/common/Sidebar";
import ClubSidebar from "../components/common/ClubSidebar";

// Admin Pages
import Dashboard from "../pages/admin/Dashboard/Dashboard";
import ClubsManagement from "../pages/admin/ClubsManagement/ClubsManagement";
import UsersManagement from "../pages/admin/UsersManagement/UsersManagement";
import PositionsManagement from "../pages/admin/PositionsManagement/PositionsManagement";
import PlayersManagement from "../pages/admin/PlayersManagement/PlayersManagement";
import TransfersManagement from "../pages/admin/TransfersManagement/TransfersManagement";
import TransferRequestsManagement from "../pages/admin/TransferRequestsManagement/TransferRequestsManagement";
import MatchesManagement from "../pages/admin/MatchesManagement/MatchesManagement";
import TournamentsManagement from "../pages/admin/TournamentsManagement/TournamentsManagement";
import ContentManagement from "../pages/admin/ContentManagement/ContentManagement";
import AdvertisementsPage from "../pages/admin/AdvertisementsPage/AdvertisementsPage";
import TicketsManagement from "../pages/admin/TicketsManagement/TicketsManagement";
import FinancialManagement from "../pages/admin/FinancialManagement/FinancialManagement";
import ReportsPage from "../pages/admin/ReportsPage/ReportsPage";
import BoardManagement from '../pages/admin/BoardManagement/BoardManagement';


// Club Pages
import ClubDashboard from "../pages/club/ClubDashboard/ClubDashboard";
import ClubProfile from "../pages/club/ClubProfile/ClubProfile";
import ClubPlayers from "../pages/club/ClubPlayers/ClubPlayers";
import ClubTournaments from "../pages/club/ClubTournaments/ClubTournaments";
import ClubMatches from "../pages/club/ClubMatches/ClubMatches";
import ClubTickets from "../pages/club/ClubTickets/ClubTickets";
import ClubFinancials from "../pages/club/ClubFinancials/ClubFinancials";
import ClubTransferRequests from "../pages/club/ClubTransferRequests/ClubTransferRequests";
import SecuritySettings from "../pages/account/SecuritySettings";
import SecurityCenter from "../pages/admin/SecurityCenter/SecurityCenter";

function AdminPage({ children }) {
  return (
    <ProtectedRoute allowedRoles={["ADMIN"]}>
      <DashboardLayout SidebarComponent={Sidebar}>
        {children}
      </DashboardLayout>
    </ProtectedRoute>
  );
}

function ClubPage({ children }) {
  return (
    <ProtectedRoute allowedRoles={["CLUB_MANAGER"]}>
      <DashboardLayout SidebarComponent={ClubSidebar}>
        {children}
      </DashboardLayout>
    </ProtectedRoute>
  );
}

export default function AppRoutes() {
  return (
    <Routes>
      {/* ================= PUBLIC ROUTES ================= */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:id" element={<NewsDetail />} />
        <Route path="/competitions" element={<Competitions />} />
        <Route path="/tournaments" element={<Tournaments />} />
        <Route path="/tournaments/:id" element={<TournamentDetails />} />
        <Route path="/clubs" element={<Clubs />} />
        <Route path="/clubs/:id" element={<ClubDetails />} />
        <Route path="/players" element={<Players />} />
        <Route path="/players/:id" element={<PlayerDetails />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Route>

      {/* ================= LOGIN ================= */}
      <Route path="/login" element={<Login />} />

      {/* ================= ADMIN ROUTES ================= */}
      <Route
        path="/admin/dashboard"
        element={
          <AdminPage>
            <Dashboard />
          </AdminPage>
        }
      />
      <Route
        path="/admin/clubs"
        element={
          <AdminPage>
            <ClubsManagement />
          </AdminPage>
        }
      />
      <Route
        path="/admin/players"
        element={
          <AdminPage>
            <PlayersManagement />
          </AdminPage>
        }
      />
      <Route
        path="/admin/transfers"
        element={
          <AdminPage>
            <TransfersManagement />
          </AdminPage>
        }
      />
      <Route
        path="/admin/transfer-requests"
        element={
          <AdminPage>
            <TransferRequestsManagement />
          </AdminPage>
        }
      />
      <Route
        path="/admin/security"
        element={
          <AdminPage>
            <SecuritySettings />
          </AdminPage>
        }
      />
      <Route
        path="/admin/security-center"
        element={
          <AdminPage>
            <SecurityCenter />
          </AdminPage>
        }
      />
      <Route
        path="/admin/matches"
        element={
          <AdminPage>
            <MatchesManagement />
          </AdminPage>
        }
      />
      <Route
        path="/admin/tournaments"
        element={
          <AdminPage>
            <TournamentsManagement />
          </AdminPage>
        }
      />
      <Route
        path="/admin/users"
        element={
          <AdminPage>
            <UsersManagement />
          </AdminPage>
        }
      />
      <Route
        path="/admin/board"
        element={
          <AdminPage>
            <BoardManagement />
          </AdminPage>
        }
      />
      <Route
        path="/admin/content"
        element={
          <AdminPage>
            <ContentManagement />
          </AdminPage>
        }
      />
      <Route
        path="/admin/advertisements"
        element={
          <AdminPage>
            <AdvertisementsPage />
          </AdminPage>
        }
      />
      <Route
        path="/admin/tickets"
        element={
          <AdminPage>
            <TicketsManagement />
          </AdminPage>
        }
      />
      <Route
        path="/admin/financials"
        element={
          <AdminPage>
            <FinancialManagement />
          </AdminPage>
        }
      />
      <Route
        path="/admin/reports"
        element={
          <AdminPage>
            <ReportsPage />
          </AdminPage>
        }
      />

      {/* ================= CLUB ROUTES ================= */}
      <Route
        path="/club/dashboard"
        element={
          <ClubPage>
            <ClubDashboard />
          </ClubPage>
        }
      />
      <Route
        path="/club/profile"
        element={
          <ClubPage>
            <ClubProfile />
          </ClubPage>
        }
      />
      <Route
        path="/club/players"
        element={
          <ClubPage>
            <ClubPlayers />
          </ClubPage>
        }
      />
      <Route
        path="/club/tournaments"
        element={
          <ClubPage>
            <ClubTournaments />
          </ClubPage>
        }
      />
      <Route
        path="/club/matches"
        element={
          <ClubPage>
            <ClubMatches />
          </ClubPage>
        }
      />
      <Route
        path="/club/transfer-requests"
        element={
          <ClubPage>
            <ClubTransferRequests />
          </ClubPage>
        }
      />
      <Route
        path="/club/security"
        element={
          <ClubPage>
            <SecuritySettings />
          </ClubPage>
        }
      />
      <Route
        path="/club/tickets"
        element={
          <ClubPage>
            <ClubTickets />
          </ClubPage>
        }
      />
      <Route
        path="/club/financials"
        element={
          <ClubPage>
            <ClubFinancials />
          </ClubPage>
        }
      />

      {/* ================= 404 - NOT FOUND ================= */}
      <Route
        path="*"
        element={
          <div
            dir="rtl"
            className="flex min-h-[60vh] items-center justify-center bg-slate-50 px-4"
          >
            <div className="text-center">
              <div className="text-7xl font-black text-emerald-500">
                404
              </div>

              <h1 className="mt-4 text-2xl font-black text-slate-900">
                صفحه پیدا نشد
              </h1>

              <p className="mt-2 text-sm text-slate-500">
                صفحه‌ای که دنبال آن هستید وجود ندارد.
              </p>

              <a
                href="/"
                className="mt-6 inline-flex rounded-xl bg-emerald-600 px-6 py-3 text-sm font-black text-white transition hover:bg-emerald-700"
              >
                بازگشت به خانه
              </a>
            </div>
          </div>
        }
      />
    </Routes>
  );
}
